import { selectTheme, getTheme, setTheme, themes, Themes } from "@/stores/themeSlice";
import { useAppDispatch, useAppSelector } from "@/stores/hooks";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import OrderNotification from "@/pages/Chef/OrderNotification";
import { addNotification } from "@/stores/notificationSlice";
import type { Notification as NT } from "@/stores/notificationSlice";
import socket from "@/utils/socket.ts";
import CustomerNotification from "@/pages/Chef/CustomerNotification";
// import { messaging, getToken, onMessage } from '@/config/firebaseConfig';

function Main() {
    const dispatch = useAppDispatch();
    const theme = useAppSelector(selectTheme);
    const selectedTheme = getTheme(theme);
    const Component = selectedTheme?.component;
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const sound = new Audio("/Bell.mp3");

    if (!Component) {
        return null;
    }

    const switchTheme = (theme: Themes["name"]) => {
        dispatch(setTheme(theme));
    };

    useEffect(() => {
        if (queryParams.get("theme")) {
            const selectedTheme = themes.find(
                (theme) => theme.name === queryParams.get("theme")
            );

            if (selectedTheme) {
                switchTheme(selectedTheme.name);
            }
        }

        socket.on("GOT_ORDER", (response: NT) => {
            if (!localStorage.getItem("token")) return;
            sound?.play?.()?.catch?.(() => {});
            dispatch(addNotification(response));
        });

        return () => {
            socket.off("GOT_ORDER");
        };

    }, []);

    useEffect(() => {
        socket.on("CALL_WAITER_SERVICE", (response: NT) => {
            if (!localStorage.getItem("token")) return;
            sound?.play?.()?.catch?.(() => {});
            dispatch(addNotification(response));
        });

        return () => {
            socket.off("CALL_WAITER_SERVICE");
        };
    }, []);

    // useEffect(() => {
    //     (async () => {
    //         try {
    //             const permission = await Notification.requestPermission();
    //             if (permission === 'granted') {
    //                 console.log('Notification permission granted.');
    //                 // Get the FCM registration token
    //                 const currentToken = await getToken(messaging, { vapidKey: 'BCjlq_fmtswzROcTUVefYcQsXUvpdeykV-_frmcuXiK1qHjce36KOZrRpFJoF3m0hlnBaRT1CHMNF2Gyi99LkmU' });
    //                 if (currentToken) {
    //                     console.log('FCM Registration Token:', currentToken);
    //                     // TODO: Send this token to your server to associate with the user
    //                 } else {
    //                     console.log('Can not get the FCM Registration Token.');
    //                 }
    //             } else {
    //                 console.log('Permission denied for notifications.');
    //             }
    //         } catch (error) {
    //             console.error('An error occurred while requesting notification permission:', error);
    //         }
    //     })()
    //
    // }, []);
    //
    // useEffect(() => {
    //     // Listen for incoming messages when the app is in the foreground
    //     const unsubscribe = onMessage(messaging, (payload) => {
    //         console.log('Message received. ', payload);
    //         //  Display notification (using browser Notification API or a library)
    //         new Notification('Notification', {
    //             body: "This is body"
    //         });
    //     });
    //
    //     return () => {
    //         unsubscribe(); // Clean up the listener when the component unmounts
    //     };
    // }, []);

    return (
        <>
            <Component/>
            <OrderNotification/>
            <CustomerNotification/>
        </>
    );
}

export default Main;
